// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.GraphicalDataSourceConnectionPoint
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { Message } from "abweb/dto/Message";
import { GraphicalDataSourceEdge } from "abweb/dto/gds/GraphicalDataSourceEdge";
import { GraphicalDataSourceNode } from "abweb/dto/gds/GraphicalDataSourceNode";
import { GraphicalDataSourceObject } from "abweb/dto/gds/GraphicalDataSourceObject";
import { NamedDataSourceRecordReference } from "abweb/dto/gds/NamedDataSourceRecordReference";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class GraphicalDataSourceConnectionPointBase extends GraphicalDataSourceObject {
  /** Do NOT invoke directly, instead use strongly typed createGraphicalDataSourceConnectionPointBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.GraphicalDataSourceConnectionPoint";
  }
  initFromJson(json, deserializeContext) {
    this.initGraphicalDataSourceConnectionPoint(TSOGUtils.decodeObject(json.dataSourceRecordReference, NamedDataSourceRecordReference, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "dataSourceRecordReference")), json.id != null ? json.id : null, json.messages != null ? TSOGUtils.decodeObjectArray(json.messages, Message, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "messages")) : null, json.state != null ? DataSourceState.fromJson(json.state) : null, json.styleClasses != null ? json.styleClasses : null, json.viewType != null ? json.viewType : null, json.edges != null ? TSOGUtils.decodeObjectArray(json.edges, GraphicalDataSourceEdge, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "edges")) : null, json.height, TSOGUtils.decodeObject(json.owningNode, GraphicalDataSourceNode, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "owningNode")), json.width, json.x, json.y);
  }
  initGraphicalDataSourceConnectionPoint(dataSourceRecordReference, id, messages, state, styleClasses, viewType, edges, height, owningNode, width, x, y) {
    this.initGraphicalDataSourceObject(dataSourceRecordReference, id, messages, state, styleClasses, viewType);
    this._edges = edges;
    this._height = height;
    this._owningNode = owningNode;
    this._width = width;
    this._x = x;
    this._y = y;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._edges != null) {
      retVal["edges"] = TSOGUtils.toTSOGArray(this._edges, serializeContext);
    }
    retVal["height"] = this._height;
    if (this._owningNode != null) {
      retVal["owningNode"] = TSOGUtils.toTSOGNativeObject(this._owningNode, serializeContext);
    }
    retVal["width"] = this._width;
    retVal["x"] = this._x;
    retVal["y"] = this._y;
    return retVal;
  }
  get edges() {
    return this._edges;
  }
  set edges(value) {
    this._edges = value;
  }
  get height() {
    return this._height;
  }
  set height(value) {
    this._height = value;
  }
  get owningNode() {
    return this._owningNode;
  }
  set owningNode(value) {
    this._owningNode = value;
  }
  get width() {
    return this._width;
  }
  set width(value) {
    this._width = value;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
  }
}
//# sourceMappingURL=GraphicalDataSourceConnectionPointBase.js.map
